<template>
	<div id="statisticsData">
		<div class="screen">
			<el-select v-model="cycleData" @change="resetData">
				<el-option label="今日数据" value="0">今日数据</el-option>
				<el-option label="本周数据" value="1">本周数据</el-option>
				<el-option label="本月数据" value="2">本月数据</el-option>
				<el-option label="年度数据" value="3">年度数据</el-option>
				<el-option label="自定义查询" value="4">自定义查询</el-option>
			</el-select>
		</div>
		<div class="screen" v-if="this.user.level=='ALL'||true">
			<el-select v-model="diyData.fieldIds" @change="searchData1('field')">
				<el-option label="全国" value="">全国</el-option>
				<el-option  v-for="item in sgfields" :key="item.field" :label="item.fueldname" :value="item.field" ></el-option>
			</el-select>
		</div>
		<div class="screen" v-if="this.user.level=='SECTION'||this.user.level=='ALL'|| true">
			<el-select v-model="diyData.relayuserids" @change="searchData1">
				<el-option label="全部" value="">全部</el-option>
				<el-option class="font-black" v-for="item in sgleaders" :key="item[0]" :label="item[1]" :value="item[0]" ></el-option>
			</el-select>
		</div>

		<div class="statisticsDataList">
			<ul>
        <li>
					新三包预警案件
					<span>{{array['新三包预警案件']}}</span>
          <div style="padding-left:20px">黄色 <span>{{array['新三包预警案件_黄色']}}</span></div>
          <div style="padding-left:20px">橙色 <span>{{array['新三包预警案件_橙色']}}</span></div>
          <div style="padding-left:20px">红色 <span>{{array['新三包预警案件_红色']}}</span></div>
				</li>
        <li>
					新发起案件
					<span>{{array['新发起案件']}}</span>
          <div style="padding-left:20px">技术支援案件 <span>{{array.xfaj}}</span></div>
          <div style="padding-left:20px">三包预警发起案件 <span>{{array['新发起案件_三包预警发起案件']}}</span></div>
          <div style="padding-left:20px">建议发起案件 <span>{{array['新发起案件_建议发起案件']}}</span></div>
				</li>
        <li>
					处理中案件
					<span>{{array['处理中案件']}}</span>
          <div style="padding-left:20px">技术支援案件 <span>{{array.clzaj}}</span></div>
          <div style="padding-left:20px">三包预警发起案件 <span>{{array['处理中案件_三包预警发起案件']}}</span></div>
          <div style="padding-left:20px">三包预警案件 <span>{{array['处理中案件_三包预警案件']}}</span></div>
				</li>
        <li>
					已结案案件
					<span>{{array['已结案案件']}}</span>
          <div style="padding-left:20px">技术支援案件 <span>{{array.yjaaj}}</span></div>
          <div style="padding-left:20px">三包预警发起案件 <span>{{array['已结案案件_三包预警发起案件']}}</span></div>
          <div style="padding-left:20px">三包预警案件 <span>{{array['已结案案件_三包预警案件']}}</span></div>
				</li>
				<!-- <li>
					新发起案件
					<span>{{array.xfaj}}</span>
				</li> -->
				<li>
					再发起案件
					<span>{{array.zfaj}}</span>
				</li>
				<li>
					未处理案件
					<span>{{array.wclaj}}</span>
				</li>
				<!-- <li>
					处理中案件
					<span>{{array.clzaj}}</span>
				</li> -->
				<li>
					退回案件
					<span>{{array.thaj}}</span>
				</li>
				<!-- <li>
					已结案案件
					<span>{{array.yjaaj}}</span>
				</li> -->
        <li class="angb">
					案件关闭率<el-input style="width: 120px;margin-left:10px" v-model="deliverElapse">
              <span slot="append" style="padding: 0">天</span>
            </el-input>
					<span>{{array.ajgbl}}</span>
				</li>
				<li>
					S+A案件数量
					<span>{{array.saCount}}</span>
				</li>
				<li>
					24小时未解决
					<span>{{array.dyl}}</span>
				</li>
				<li>
					24小时解决率
					<span>{{array.jjl}}</span>
				</li>
				<li>
					平均结案L/T
					<span>{{array.pjjal}}</span>
				</li>
				<li>
					现认
					<span>{{array.xrCount}}</span>
				</li>
				<li>
					RSR
					<span>{{array.rsrCount}}</span>
				</li>
        
			</ul>
		</div>
		<div>
			<router-link to="excel">
				<el-button type="primary">非三包预警相关案件导出</el-button>
				
			</router-link>
      <router-link to="alarmExcel">
				<el-button type="primary">三包预警相关案件导出</el-button>
				
			</router-link>
		</div>
		<div class="screenDiy" v-if="diyDom">
			<div class="screenDiyDom">
				<div class="container">
					<el-row>
						<el-form label-position="top" label-width="80px" :model="diyData">
							<el-form-item label="开始时间" style="text-align: left;margin-bottom:0px">
								<el-date-picker v-model="diyData.startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
							<el-form-item label="结束时间" style="text-align: left">
								<el-date-picker v-model="diyData.endTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
							<!-- <div class="statisticsel-option">
								<h4>类型</h4>
								<ul>
									<span @click="modifyTypeClick('一般维修')" :class="{selectionBg:modifytype.indexOf('一般维修')!=-1}">一般维修</span>
									<span @click="modifyTypeClick('钣金喷漆')" :class="{selectionBg:modifytype.indexOf('钣金喷漆')!=-1}">钣金喷漆</span>
									<span @click="modifyTypeClick('故障码')" :class="{selectionBg:modifytype.indexOf('故障码')!=-1}">故障码</span>
								</ul>
							</div>
							<div class="statisticsOption">
								<h4>状态</h4>
								<ul>
									<span @click="modifyStateClick('未处理')" :class="{selectionBg:modifystate.indexOf('未处理')!=-1}">未处理</span>
									<span @click="modifyStateClick('处理中')" :class="{selectionBg:modifystate.indexOf('处理中')!=-1}">处理中</span>
									<span @click="modifyStateClick('结案')" :class="{selectionBg:modifystate.indexOf('结案')!=-1}">结案</span>
								</ul>
							</div> -->
							<el-form-item style="text-align: center; margin-top:30px">
								<el-button type="info" @click="cancels()">取消</el-button>
								<el-button type="success" @click="searchBtn()">确定</el-button>
							</el-form-item>
						</el-form>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
  getStat,
  postStat
} from '@/api/stat'
import {
  getDefaultTableData,
  getOptions,
  getTableData,
  getArealist1,
  getArealist,
  getArealist2,
  getLeader
} from '@/api/export.js'
import { switchLevels } from '@/api/case.js'
export default {
  data () {
    return {
      diyDom: false, // Diy筛选Dom
      sgleaders: [],
      deliverElapse: 7,
      diyData: {
        // Diy摘选
        startTime: '',
        endTime: '',
        relayuserids: '',
        fieldIds: ''
        // kubun: "未处理",
        // status: "未处理"
      },
      modifytype: '一般维修',
      modifystate: '未处理',

      time: 'today',
      array: {
        xfaj: null,
        zfaj: null,
        wclaj: null,
        clzaj: null,
        yjaaj: null,
        saCount: null,
        dyl: null,
        jjl: null,
        pjjal: null,
        xrCount: 0,
        rsrCount: 0,
        thaj: 0,
        ajgbl: 0
      },
      cycleData: '0', // 筛选周期&DIY搜索
      relayuserids: '',
      sgfields: [],
      fieldIds: '',
      user: {
      }
    }
  },
  created () {
    if (localStorage.getItem('user')) {
      this.user = JSON.parse(localStorage.getItem('user'))
      console.log(this.user)
      if (JSON.parse(localStorage.getItem('user')).level == 'ALL') {
        switchLevels('ALL').then(res => {
          // 初始化案件
          this.searchData1()
        })
      }else if (JSON.parse(localStorage.getItem('user')).levels.includes('SECTION')) {
          switchLevels('SECTION').then(res => {
          // 初始化案件
          this.searchData1()
        })
      }else {        
        this.searchData1()
	  }
    }
  },
  methods: {
    // 根据输入的内容检索数据
    searchData (time, diyData) {
      let that = this
      getStat(time, diyData).then(res => {
        let arr = {
          xfaj: res.data['新发起案件'],
          zfaj: res.data['再发起案件'],
          wclaj: res.data['未处理案件'],
		  clzaj: res.data['处理中案件'],
		  thaj: res.data['退回案件'],
          saCount: res.data['S+A案件数量'],
          yjaaj: res.data['已结案案件'],
          dyl: res.data['24小时未解决'],
          jjl: res.data['24小时解决率'],
          pjjal: res.data['平均结案LT'],
          xrCount: res.data['现认'],
          rsrCount: res.data['RSR'],
          ajgbl: res.data['案件关闭率'],
          ...res.data
        }
        console.log(arr)
        that.array = arr
      })
    },
    changefield () {
      console.log(1)
    },
    searchData1 (diyData) {
      if (diyData == 'field') {
        getArealist2(this.diyData.fieldIds).then(res => {
          this.sgleaders = res.data.data
          this.diyData.relayuserids = ''
        })
      }
      let that = this
      this.diyData.time = this.time
      this.diyData.deliverElapse = this.deliverElapse
      postStat(this.diyData).then(res => {
        let arr = {
          xfaj: res.data['新发起案件'],
          zfaj: res.data['再发起案件'],
          wclaj: res.data['未处理案件'],
          clzaj: res.data['处理中案件'],
          thaj: res.data['退回案件'],
          saCount: res.data['S+A案件数量'],
          yjaaj: res.data['已结案案件'],
          dyl: res.data['24小时未解决'],
          jjl: res.data['24小时解决率'],
          pjjal: res.data['平均结案LT'],
          xrCount: res.data['现认'],
          rsrCount: res.data['RSR'],
          ajgbl: res.data['案件关闭率'] ? res.data['案件关闭率'] : '',
          ...res.data
        }
        that.array = arr
      })
    },

    // 根据选项获取数据
    resetData () {
      let cycleDataTest = null
      switch (this.cycleData) {
        case '0':
          cycleDataTest = 'today'
          break
        case '1':
          cycleDataTest = 'week'
          break
        case '2':
          cycleDataTest = 'month'
          break
        case '3':
          cycleDataTest = 'year'
          break
        case '4':
          cycleDataTest = 'customize'
          break
        default:
          cycleDataTest = 'today'
      }
      if (cycleDataTest) {
        // this.getDefault(cycleDataTest)
        this.time = cycleDataTest
        this.searchData1()
      }
    },

    // 日、周、月、年检索数据条数（默认为当天）
    getDefault (time) {
      let that = this
      getStat(time).then(res => {
        let arr = {
          xfaj: res.data['新发起案件'],
          zfaj: res.data['再发起案件'],
          wclaj: res.data['未处理案件'],
          clzaj: res.data['处理中案件'],
          thaj: res.data['退回案件'],
          saCount: res.data['S+A案件数量'],
          yjaaj: res.data['已结案案件'],
          dyl: res.data['24小时未解决'],
          jjl: res.data['24小时解决率'],
          pjjal: res.data['平均结案LT'],
          xrCount: res.data['现认'],
          rsrCount: res.data['RSR'],
          ajgbl: res.data['案件关闭率']
        }
        that.array = arr
      })
    },

    modifyTypeClick (e) {
      // 维修类型
      this.modifytype = e
      this.diyData.kubun = e
    },
    modifyStateClick (e) {
      // 维修状态
      this.modifystate = e
      this.diyData.status = e
    },
    cancels () {
      // 取消Diy搜索
      this.cycleData = '0'
      this.diyDom = false
    },
    searchBtn () { // 确认搜索
      this.diyDom = false
      console.log(this.diyData)
      this.searchData1(this.diyData)
    }
  },
  mounted () {
    // this.getDefault(this.time);

    let now = new Date()
    let y = now.getFullYear()
    let m = (now.getMonth() + 1) >= 10 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1)
    let d = now.getDate() >= 10 ? now.getDate() : '0' + now.getDate()
    this.diyData.startTime = y + '-' + m + '-' + d
    this.diyData.endTime = y + '-' + m + '-' + d
    getLeader().then(res => {
      res.data.data.forEach(v => {
        if (v[0]) {
          this.sgleaders.push(v)
        }
      })
      // this.diyData.relayuserids = this.sgleaders[0][0]
      // this.diyData.relayuserids = ''
    })
    getArealist().then(res => {
      this.sgfields = res.data.data
    })
  },
  watch: {
    cycleData: function () {
      if (this.cycleData != 4) {
        this.diyDom = false
      } else {
        this.diyDom = true
      }
    }
  }
}
</script>

<style>
	#statisticsData {
		max-width: 500px;
		margin: 0 auto;
		padding: 10px 0;
	}

	#statisticsData .screen {
		width: 100%;
		height: 44px;
		background-color: #ffffff;
		margin-bottom: 15px;

	}

	#statisticsData .screen select {
		width: 100%;
		height: 44px;
		border: 1px solid #ffffff;
		text-indent: 2em;
		background: #fff;
		outline:none;
	}

	#statisticsData .statisticsDataList {
		overflow: hidden;
		text-align: left;
	}

	#statisticsData .statisticsDataList li {
		width: 100%;
		background-color: #ffffff;
		margin-bottom: 5px;
		text-indent: 1em;
		font-size: 14px;
		line-height: 44px;
	}

	#statisticsData .statisticsDataList li span {
		float: right;
		margin-right: 15px;
	}

	#statisticsData .screenDiy {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}

	#statisticsData .screenDiyDom {
		max-width: 500px;
		margin: 0 auto;
		height: 100%;
		background: #fff;
	}

	#statisticsData .container {
		padding: 15px;
	}

	#statisticsData .statisticsOption {
		text-align: left;
	}

	#statisticsData .statisticsOption ul {
		overflow: hidden;
		margin-bottom: 15px;
	}
  .angb .el-input-group__append{
    margin-left: 0px;
    padding: 0;
  }
	#statisticsData .statisticsOption span {
		display: block;
		padding: 5px 15px;
		float: left;
		border-radius: 3px;
		margin-right: 10px;
		background-color: #f4f4f4;
		color: #999;
	}

	#statisticsData .selectionBg {
		background-color: #00ae66 !important;
		color: #fff !important;
	}

	#statisticsData .statisticsOption h4 {
		font-weight: normal;
		color: #666;
	}

	.font-black {
		color: black;
	}
</style>
